import { GET_INQUIRY, SET_LOADING_INQUIRY, SET_PAGINATION_INQUIRY } from '../constant';

const initialState = {
  inquiry: [],
  inquiryPagination: 0,
  loadingInquiry: false,
  totalInquiry: 0,
};

const inquiryReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING_INQUIRY: {
      return {
        ...state,
        loadingInquiry: action?.payload,
      };
    }
    case SET_PAGINATION_INQUIRY: {
      return {
        ...state,
        inquiryPagination: action?.payload,
      };
    }
    case GET_INQUIRY: {
      return {
        ...state,
        inquiry: action?.payload?.data || [],
        totalInquiry: action?.payload?.total,
        loadingInquiry: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default inquiryReducer;
